import { render, staticRenderFns } from "./ViewCrewBehaviour.vue?vue&type=template&id=346f4f4d&scoped=true&"
import script from "./ViewCrewBehaviour.vue?vue&type=script&lang=js&"
export * from "./ViewCrewBehaviour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346f4f4d",
  null
  
)

export default component.exports